import { ITheme } from '@psyomics/surveyjs-core';

export const psyomicsCustomTheme: ITheme = {
  themeName: 'psyomics-custom',
  colorPalette: 'light',
  cssVariables: {
    '--font-family': 'var(--font-family)',

    '--sjs-article-font-default-fontSize': 'var(--text-large)',
    '--sjs-article-font-default-fontStretch': 'normal',
    '--sjs-article-font-default-fontStyle': 'normal',
    '--sjs-article-font-default-fontWeight': '400',
    '--sjs-article-font-default-letterSpacing': '0',
    '--sjs-article-font-default-lineHeight': '20px',
    '--sjs-article-font-default-paragraphIndent': '0px',
    '--sjs-article-font-default-textCase': 'none',
    '--sjs-article-font-default-textDecoration': 'none',
    '--sjs-article-font-large-fontStretch': 'normal',
    '--sjs-article-font-large-fontStyle': 'normal',
    '--sjs-article-font-large-fontWeight': '600',
    '--sjs-article-font-large-letterSpacing': '0',
    '--sjs-article-font-large-lineHeight': '28px',
    '--sjs-article-font-large-paragraphIndent': '0px',
    '--sjs-article-font-large-textCase': 'none',
    '--sjs-article-font-large-textDecoration': 'none',
    '--sjs-article-font-medium-fontStretch': 'normal',
    '--sjs-article-font-medium-fontStyle': 'normal',
    '--sjs-article-font-medium-fontWeight': '500',
    '--sjs-article-font-medium-letterSpacing': '0',
    '--sjs-article-font-medium-lineHeight': '24px',
    '--sjs-article-font-medium-paragraphIndent': '0px',
    '--sjs-article-font-medium-textCase': 'none',
    '--sjs-article-font-medium-textDecoration': 'none',
    '--sjs-article-font-x-large-fontStretch': 'normal',
    '--sjs-article-font-x-large-fontStyle': 'normal',
    '--sjs-article-font-x-large-fontWeight': '600',
    '--sjs-article-font-x-large-letterSpacing': '0',
    '--sjs-article-font-x-large-lineHeight': '32px',
    '--sjs-article-font-x-large-paragraphIndent': '0px',
    '--sjs-article-font-x-large-textCase': 'none',
    '--sjs-article-font-x-large-textDecoration': 'none',

    '--sjs-base-unit': '8px',

    '--sjs-border-default': 'var(--color-neutral-500)',
    '--sjs-border-inside': 'var(--color-neutral-400)',
    '--sjs-border-light': 'var(--color-neutral-300)',

    '--sjs-corner-radius': '8px',

    '--sjs-default-font-family': 'var(--font-family)',
    '--sjs-font-family': 'var(--font-family)',
    '--sjs-font-headerdescription-color': 'var(--color-typography)',
    '--sjs-font-pagetitle-color': 'var(--color-typography)',
    '--sjs-font-questiontitle-color': 'var(--color-typography)',
    '--sjs-font-questiontitle-family': 'var(--font-family)',
    '--sjs-font-questiontitle-weight': '500',
    '--sjs-font-size': 'var(--text-lg)',

    '--sjs-general-backcolor': 'var(--color-neutral-0)',
    '--sjs-general-backcolor-dark': 'var(--color-neutral-100)',
    '--sjs-general-backcolor-dim': 'var(--color-neutral-100)',
    '--sjs-general-backcolor-dim-dark': 'var(--color-neutral-400)',
    '--sjs-general-backcolor-dim-light': 'var(--color-neutral-300)',
    '--sjs-general-dim-forecolor': 'var(--color-neutral-800)',
    '--sjs-general-dim-forecolor-light': 'var(--color-neutral-700)',
    '--sjs-general-forecolor': 'var(--color-typography)',
    '--sjs-general-forecolor-light': 'var(--color-typography-light)',

    '--sjs-primary-backcolor': 'var(--color-primary-500)',
    '--sjs-primary-backcolor-dark': 'var(--color-primary-700)',
    '--sjs-primary-backcolor-light': 'var(--color-primary-300)',
    '--sjs-primary-forecolor': 'var(--color-neutral-0)',
    '--sjs-primary-forecolor-light': 'var(--color-primary-200)',

    '--sjs-secondary-backcolor': 'var(--color-secondary-500)',
    '--sjs-secondary-backcolor-light': 'var(--color-secondary-300)',
    '--sjs-secondary-backcolor-semi-light': 'var(--color-secondary-400)',
    '--sjs-secondary-forecolor': 'var(--color-typography)',
    '--sjs-secondary-forecolor-light': 'var(--color-neutral-800)',

    '--sjs-special-blue': 'var(--color-primary-500)',
    '--sjs-special-blue-forecolor': 'var(--color-neutral-0)',
    '--sjs-special-blue-light': 'var(--color-primary-200)',
    '--sjs-special-green': 'var(--color-status-green)',
    '--sjs-special-green-forecolor': 'var(--color-neutral-0)',
    '--sjs-special-green-light': 'var(--color-green-200)',
    '--sjs-special-red': 'var(--color-status-horizon-scarlett)',
    '--sjs-special-red-forecolor': 'var(--color-neutral-0)',
    '--sjs-special-red-light': 'var(--color-pink-300)',
    '--sjs-special-yellow': 'var(--color-status-amber)',
    '--sjs-special-yellow-forecolor': 'var(--color-typography)',
    '--sjs-special-yellow-light': 'var(--color-yellow-200)',
  },
  isPanelless: false,
};
